import * as RadixSeparator from '@/app_components/ui/primitives/Separator';
import { cn } from '@/app_lib/utils/utils';

interface SeparatorProps {
  className?: string;
  decorative?: boolean;
}

export const HorizontalSeparator = ({ className, decorative = false }: SeparatorProps) => (
  <RadixSeparator.Root
    className={cn('w-full border-b', className)}
    decorative={decorative}
    orientation='horizontal'
  />
);

export const VerticalSeparator = ({ className, decorative = false }: SeparatorProps) => (
  <RadixSeparator.Root
    className={cn('h-auto border-l', className)}
    decorative={decorative}
    orientation='vertical'
  />
);
